const CREATIVE_VERSION = 6;

import postEffects from 'view/audioTracker/postEffects';
import _ from 'lodash';

export {
	CREATIVE_VERSION
}

export default {
	methods: {
		async checkVersionUpdate() {
			if (!this.creative?.JsonConfig) return;
			
			if (__DEBUG__)
				console.debug('Check creative version update', { loadedVersion: this.loadedCreativeVersion, currentVersion: CREATIVE_VERSION, creativeVersion: this.creative?.JsonConfig?.creativeVersion });

			if (this.loadedCreativeVersion) {
				//Fix
			}

			if (parseInt(CREATIVE_VERSION) !== parseInt(this.creative?.JsonConfig.creativeVersion)) {
				this.creative.JsonConfig.creativeVersion = CREATIVE_VERSION;
				this.updateCreative('checkVersionUpdate', true);
			}
		}
	},
	CREATIVE_VERSION
};
